import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import { useApi } from "../../../../hooks/useApi";
import useGradeList from "../../../../hooks/useGradeList";
import useMy from "../../../../hooks/useMy";
import { userDataType } from "../../../../pages/Login";
import { ManagerDataProps } from "../../../../pages/Manage/ManageAuth";
import Blank from "../../../DefaultStyles/Blank";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { Input } from "../../../Input/Input";
import { Textarea } from "../../../Input/Textarea";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { DeleteModalLabel } from "../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import {
  CommentTargetContainer,
  ModalLabel,
} from "../../Users/UserDetail/CommentModal/TargetContainer";
import { checkIsEmailType } from "../../../../Api/ApiCommon";
import LoginErrorMessage from "../../../Login/LoginErrorMessage";

interface SManageModalInput {
  wrongEmailType?: boolean;
}

interface ManageModalProps extends DefaultModalCommonProps {
  managerData?: ManagerDataProps;
  updateEvent: () => void;
}

export default function ManageModal({
  closeEvent,
  managerData,
  updateEvent,
}: ManageModalProps) {
  console.log(managerData);
  const gradeOption = useGradeList();

  const { name: myName, email: myEmail } = useMy();
  const [userData, setUserData] = useRecoilState(userDataType);

  const [reason, setReason] = useState("");
  const [name, setName] = useState(managerData?.name ?? "");
  const [email, setEmail] = useState(managerData?.email ?? "");
  const [wrongEmailType, setWrongEmailType] = useState(false);
  const [gradeDropdown, setGradeDropdown] = useState<OptionType>({
    value: managerData?.grade ?? "",
    label: managerData?.gradeString ?? "선택",
  });
  const [addConfirmBtnClick, setAddConfirmBtnClick] = useState(false);
  const [editConfirmBtnClick, setEditConfirmBtnClick] = useState(false);

  // 관리자 추가
  const { response: addResponse, error: addError } = useApi({
    method: "post",
    url: addConfirmBtnClick ? "admin" : undefined,
    data: {
      name,
      email,
      adminGrade: Number(gradeDropdown?.value),
      reason,
    },
  });

  console.log(gradeDropdown);

  // 관리자 변경
  const { response: editResponse, error: editError } = useApi({
    method: "post",
    url: editConfirmBtnClick ? `admin/${managerData?.id}` : undefined,
    data: {
      adminGrade: Number(gradeDropdown?.value),
      reason,
    },
  });

  useEffect(() => {
    if (addResponse?.status === 200) {
      closeEvent();
      updateEvent();

      toast.success("관리자가 추가 되었습니다.");
    }
  }, [addResponse, closeEvent]);

  useEffect(() => {
    if (editResponse?.status === 200) {
      if (myName === name && email === myEmail) {
        setUserData((prevState: any) => ({
          ...prevState,
          grade: String(gradeDropdown?.value),
        }));

        sessionStorage.setItem("grade", String(gradeDropdown?.value));
      }

      closeEvent();
      updateEvent();

      toast.success("관리자가 변경 되었습니다.");
    }
  }, [editResponse]);

  return (
    <DefaultModalLayout
      modalTitle={managerData ? "관리자 변경" : "관리자 추가"}
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        if (managerData) {
          setEditConfirmBtnClick(true);
        } else {
          if (checkIsEmailType(email)) {
            setWrongEmailType(false);
            setAddConfirmBtnClick(true);
          } else {
            setWrongEmailType(true);
          }
        }
      }}
      confirmBtnText={managerData ? "변경" : "추가"}
      confirmDisabled={
        name === "" ||
        email === "" ||
        (managerData
          ? gradeDropdown?.value === managerData?.grade
          : gradeDropdown?.value === "") ||
        reason === ""
      }
    >
      <>
        {/* 이름 */}
        <ModalRow>
          <ModalLabel>이름</ModalLabel>

          <CommentTargetContainer>
            <Input
              placeholder="직접 입력"
              value={name}
              onChange={(e) => setName(e.target.value)}
              readOnly={managerData ? true : false}
            />
          </CommentTargetContainer>
        </ModalRow>

        {/* 아이디 */}
        <ModalRow>
          <ModalLabel>이메일</ModalLabel>

          <CommentColumnTargetContainer>
            <ManageModalInput
              placeholder="이메일 주소 입력"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              readOnly={managerData ? true : false}
              type="email"
              wrongEmailType={wrongEmailType}
            />

            {wrongEmailType && (
              <LoginErrorMessage msg="올바른 이메일 형식을 입력해 주세요." />
            )}
          </CommentColumnTargetContainer>
        </ModalRow>

        {/* 등급 선택 */}
        <ModalRow>
          <ModalLabel>등급 선택</ModalLabel>

          <CommentTargetContainer>
            <DropDown
              dropdownValue={gradeDropdown}
              setDropDownValue={setGradeDropdown}
              optionList={gradeOption}
              boxWidth={330}
            />
          </CommentTargetContainer>
        </ModalRow>

        {/* 사유 */}
        <DeleteModalLabel>
          {managerData ? "변경 사유" : "추가 사유"}
        </DeleteModalLabel>

        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={
            managerData
              ? "변경 사유 직접 입력 (100글자 이내)"
              : "추가 사유 직접 입력 (100글자 이내)"
          }
        />

        <Blank blankHeight={40} />
        <div style={{ width: "100%", height: 40 }} />
      </>
    </DefaultModalLayout>
  );
}

const CommentColumnTargetContainer = styled(CommentTargetContainer)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const ManageModalInput = styled(Input)<SManageModalInput>`
  background-color: ${({ wrongEmailType, theme }) =>
    wrongEmailType ? theme.color.white : theme.color.bgColor};
  border-color: ${({ wrongEmailType, theme }) =>
    wrongEmailType ? theme.buttonColor.redNormal : "transparent"};

  &:not(:read-only) {
    &:focus {
      border-color: ${({ theme, wrongEmailType }) =>
        wrongEmailType
          ? theme.buttonColor.redNormal
          : theme.buttonColor.blueHover};
    }
  }
`;
